import "./TrustHighlights.css";

const highlights = [
  {
    icon: "👨‍⚕️",
    title: "Qualified Specialist",
    desc: "Our doctors carry advanced MDS qualifications with specialised expertise in oral surgery and dental implants.",
  },
  {
    icon: "🔬",
    title: "State-of-the-Art Equipment",
    desc: "We use the most advanced dental technology available, ensuring precise diagnosis and comfortable treatments.",
  },
  {
    icon: "🏠",
    title: "Patient-Friendly Clinic",
    desc: "A warm, welcoming environment designed to keep you relaxed and at ease from the moment you walk in.",
  },
];

const numbers = [
  { val: "500+", label: "Patients Treated" },
  { val: "98%", label: "Satisfaction Rate" },
  { val: "20+", label: "Dental Services" },
  { val: "4.5+", label: "Rating" },
];

export default function TrustHighlights() {
  return (
    <section className="trust">
      <div className="trust-inner">
        <div className="trust-header">
          <span className="section-tag">Why Choose Us</span>
          <h2 className="section-title">Trust Highlights</h2>
          <p className="section-subtitle">
            We combine clinical excellence with genuine compassion — here's what sets Krishna Dental apart.
          </p>
        </div>

        <div className="trust-cards">
          {highlights.map((h, i) => (
            <div key={h.title} className="trust-card" style={{ animationDelay: `${i * 0.15}s` }}>
              <div className="trust-icon">{h.icon}</div>
              <h3 className="trust-title">{h.title}</h3>
              <p className="trust-desc">{h.desc}</p>
            </div>
          ))}
        </div>

        <div className="trust-numbers">
          {numbers.map((n) => (
            <div key={n.label} className="trust-num">
              <span className="trust-num-val">{n.val}</span>
              <span className="trust-num-label">{n.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}